import new_icon from "../assets/icons/quadri/added.svg"
import updated_icon from "../assets/icons/quadri/modified.svg"
import deleted_icon from "../assets/icons/quadri/deleted.svg"

export const TaskStatusIcon = (props: { taskStatus?: string }) => {
  const { taskStatus } = props
  let iconSrc, altText

  if (taskStatus) {
    switch (taskStatus.toUpperCase()) {
      case "DELETED":
        iconSrc = deleted_icon
        altText = "deleted"
        break
      case "NEW":
        iconSrc = new_icon
        altText = "new"
        break
      case "UPDATED":
        iconSrc = updated_icon
        altText = "updated"
        break
      default:
        console.error("Unknown task status: ", taskStatus)
        return <></>
    }
  }

  if (taskStatus) {
    return <img src={iconSrc} alt={altText} width="20" height="20" />
  } else {
    return <></>
  }
}
